module.exports = __webpack_public_path__ + "img/payment-banner.c5988f97.png";